// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverClipRequest {
	periodStart: string | undefined;

	periodEnd: string | undefined;

	desiredWidth: number | undefined;

	desiredHeight: number | undefined;

	desiredFps: number | undefined;

	desiredBps: number | undefined;

	$type?: string | undefined;
}
export class DriverClipRequest {
	constructor(data?: IDriverClipRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.periodStart) { this.periodStart = new Date(data.periodStart); }
		if (data.periodEnd) { this.periodEnd = new Date(data.periodEnd); }
	}

	periodStart: Date | undefined = new Date();

	periodEnd: Date | undefined = new Date();

	desiredWidth: number | undefined;

	desiredHeight: number | undefined;

	desiredFps: number | undefined;

	desiredBps: number | undefined;

	static $type: string = "CoreApi.Models.DriverClipRequest, ";
	$type?: string | undefined = DriverClipRequest.$type;
}

